import React from "react";
import { TESTIMONIALS } from "../../data/content";
export function Testimonials() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-224" data-mp="3hgxti1yhkfob">
      <div className="max-w-6xl mx-auto" data-id="element-225" data-mp="3mh2bxxiyfkh6">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase mb-10" data-id="element-226" data-mp="3mg0p6vskt9jm">
          ❤️ Más emprendedores que <span className="text-[#e10600]" data-id="element-227" data-mp="3r9lnyq1zu7jv">ya empezaron</span>
        </h2>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-228" data-mp="g0iwuetbwh">
          {TESTIMONIALS.map(t => <figure key={t.name} className="bg-black border border-neutral-800 rounded-2xl p-6" data-id="element-229" data-mp="41887lnmv8qn">
              <div className="flex items-center gap-3 mb-3" data-id="element-230" data-mp="92fefga4nzv7">
                <div className="w-11 h-11 rounded-full bg-[#e10600] flex items-center justify-center font-display text-white" data-id="element-231" data-mp="e1ij2zm7442n">
                  {t.initials}
                </div>
                <div data-id="element-232" data-mp="2fsc2xz37v7gg">
                  <div className="text-yellow-400 text-sm leading-none" data-id="element-233" data-mp="2frkauy8tvrux">⭐⭐⭐⭐⭐</div>
                  <div className="text-white font-semibold text-sm mt-1" data-id="element-234" data-mp="1sk9e4okoesf9">{t.name}</div>
                </div>
              </div>
              <div className="text-xs text-neutral-500 mb-3" data-id="element-235" data-mp="1nsrlcnst3y5d">
                📍 {t.location} | {t.product}
              </div>
              <blockquote className="text-neutral-300 text-sm leading-relaxed" data-id="element-236" data-mp="1iuzhqwisunlc">"{t.quote}"</blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}